import React from 'react';
import OBSView from '../../components/OBSView';

const OBSViewPage = () => <OBSView />;

export default OBSViewPage;
